import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      storeGameId: state => state.gameId,
      loginType: state => state.login.loginType
    }),
    // 是否是GS登录
    isGsPay() {
      return this?.loginType == 3;
    },
    // 是否是补单登录
    isSupplementaryPay() {
      return this?.loginType == 2;
    },
    // 是否是GS或者补单登录,限制游戏
    isGsOrSupPayAutoSelect() {
      return (
        (this.isGsPay || this.isSupplementaryPay)
      );
    },
    // GS或者补单链接，价格列表倒序
    curPricesList() {
      if (this.isGsOrSupPayAutoSelect) {
        return this.pricesList.slice().reverse();
      } else {
        return this.pricesList;
      }
    }
  }
};
